import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Link, Typography } from "@mui/material";
import supportLogo from "../../assets/images/supportLogo.png";
import { setNotificationAction } from "../../store/reducers/mmymSlice";

const SuperAdminSupport = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [])

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      sx={{ background: "#f4f4f4", height: "90vh" }}
    >
      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box sx={{ display: "flow" }}>
          <Typography variant="h2" align="center">
            <Link>tawk.to</Link> integration
          </Typography>

          <img
            src={supportLogo}
            alt="logo"
            style={{ width: "auto", height: "164px" }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
export default SuperAdminSupport;
